module.exports = __webpack_public_path__ + "static/media/stenobothrus_stigmaticus_003_APA.c024b152.png";